import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
import { CtaButton } from './CtaButton';
export function FinalUrgency() {
  return <section className="w-full bg-base" data-id="element-67" data-mp="2k85ih492uzur">
      <div className="mx-auto max-w-3xl px-5 py-14 md:py-16" data-id="element-68" data-mp="2k9gnt8i68fnz">
        <SectionReveal data-id="element-69" data-mp="2p6yxx27xd0xk">
          <div className="rounded-2xl border border-accent/25 bg-accent/5 px-6 py-8 text-center shadow-sm sm:px-10" data-id="element-70" data-mp="2p8a4f9sr8msd">
            <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-accent text-white" data-id="element-71" data-mp="3cxciy8s3dzin">
              <AlertCircleIcon className="h-5 w-5" strokeWidth={2.5} data-id="element-72" data-mp="3hv4j1q2w4rxx" />
            </span>
            <p className="mx-auto mt-4 max-w-xl text-xl font-black leading-snug text-ink sm:text-2xl" data-id="element-73" data-mp="32y3vlyrqfj59">
              Aseguradoras: 1° de Septiembre. No esperes a agosto para notificar
              a tu cartera.
            </p>
            <CtaButton className="mt-6 w-full sm:w-auto" data-id="element-74" data-mp="1rlt55z0gnz3z">
              → QUIERO MI ESTUDIOPACK — $27.990 ARS
            </CtaButton>
          </div>
        </SectionReveal>
      </div>
    </section>;
}